import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupsIcon from '@mui/icons-material/Groups';
import SportsMmaIcon from '@mui/icons-material/SportsMma';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  containerVariants,
  fadeIn,
  gloveVariants,
  linkContainerVariants,
  linkItemVariants,
} from '../styles/animations';

const links = [
  {
    title: 'View Your Team',
    path: '/teamviewer',
    icon: GroupsIcon,
  },
  {
    title: 'Build Your Team',
    path: '/teamselector',
    icon: SportsMmaIcon,
  },
  {
    title: 'Join Tournaments',
    path: '/tournaments',
    icon: EmojiEventsIcon,
  },
];

export const LinksSection = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container>
      <Box
        component={motion.div}
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.3 }}
        variants={containerVariants}
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '100px 0',
        }}
      >
        <motion.div variants={fadeIn}>
          <Typography
            variant="h2"
            sx={{
              fontFamily: 'Rubik Mono One',
              fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
              color: '#ffffff',
              marginBottom: '60px',
              textAlign: 'center',
            }}
          >
            Start Your Fantasy MMA Journey
          </Typography>
        </motion.div>

        <Box
          component={motion.div}
          variants={linkContainerVariants}
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            gap: { xs: '40px', md: '120px' },
            width: '100%',
            maxWidth: '1200px',
            flexWrap: 'wrap',
            padding: '0 20px',
          }}
        >
          {links.map((link, index) => (
            <motion.div
              key={index}
              onClick={() => navigate(link.path)}
              variants={linkItemVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false }}
              whileHover="hover"
              style={{
                position: 'relative',
                width: isMobile ? '150px' : '200px',
                height: isMobile ? '150px' : '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
            >
              <motion.div
                variants={gloveVariants}
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <link.icon
                  sx={{
                    fontSize: isMobile ? '100px' : '150px',
                    color: '#cc0000',
                    filter: 'drop-shadow(0 8px 16px rgba(204, 0, 0, 0.3))',
                    transition: 'all 0.3s ease',
                  }}
                />
              </motion.div>

              <motion.div
                variants={{
                  hover: {
                    scale: 1.1,
                    textShadow: '0 0 15px rgba(255, 255, 255, 0.8)',
                    transition: { duration: 0.3 },
                  },
                }}
                style={{
                  position: 'absolute',
                  textAlign: 'center',
                  zIndex: 2,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Rubik Mono One',
                    fontSize: 'clamp(0.8rem, 1.5vw, 1.2rem)',
                    color: '#ffffff',
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
                    padding: '8px 16px',
                    position: 'relative',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.3s ease',
                    pointerEvents: 'none',
                  }}
                >
                  {link.title}
                </Typography>
              </motion.div>
            </motion.div>
          ))}
        </Box>
      </Box>
    </Container>
  );
};
